export default __webpack_public_path__ + "../staticImages/icon-success-delay.gif";